var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinyhouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#020202;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.2,
    y1: 242.3,
    x2: 235.6,
    y2: 242.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.2,84.4 25.5,116.7 25.5,52.5 64.2,52.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46,
    cy: 222.7,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46,
    cy: 188.5,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 46,
    cy: 151.9,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 202.9,
    cy: 222.7,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 202.9,
    cy: 188.5,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 202.9,
    cy: 151.9,
    r: 17.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.7,241.3v-65c0,0,4.2-17.6,24.2-17.6s26,14,26,17.8v65.3H100L99.7,241.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 54.6,
    y1: 205.4,
    x2: 98.1,
    y2: 205.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 149.5,
    y1: 206.1,
    x2: 194.4,
    y2: 206.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.7,
    y1: 169.6,
    x2: 101.2,
    y2: 169.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 149.5,
    y1: 170.3,
    x2: 197.5,
    y2: 170.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 42.6,
    y1: 132.5,
    x2: 209,
    y2: 132.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 81.9,
    y1: 98.8,
    x2: 167.2,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.6,150.1 5,134.6 124.4,33.5 244.5,134.3 246.2,135.7 230.6,150.8 124.6,62.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyhouse);
export default __webpack_public_path__ + "static/media/tinyhouse.1840825c.svg";
export { ForwardRef as ReactComponent };